module.exports = __webpack_public_path__ + "img/address.46473ccb.png";